import { ViewInformationUsersComponent } from './view-users/view-users.component';
import { AddUsersComponent } from './add-users/add-users.component';
import { EditUsersComponent } from './edit-users/edit-users.component';


export const UsersRouting = [
    { path: '', redirectTo: 'view-users', pathMatch: 'full' },
    
    { path: 'add-users', component: AddUsersComponent},
    { path: 'view-users', component: ViewInformationUsersComponent},
    { path: 'edit-users/:userId', component: EditUsersComponent},

 

];

